export default "<ngx-ui-loader\n  fgsSize=\"70\"\n  bgsType=\"ball-spin-clockwise\"\n  blur=12\n></ngx-ui-loader>\n";